import { Box } from '@mui/material'
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid'

export const UserTableToolbar = () => {
  return (
    <GridToolbarContainer
      sx={{
        p: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        position: 'relative'
      }}
    >
      <GridToolbarColumnsButton
        sx={{
          '&.MuiButton-root': {
            backgroundColor: '#FC3E6F',
            color: 'white',
            minWidth: 'auto',
            padding: '6px 16px',
            '&:hover': {
              backgroundColor: '#e53958'
            }
          },
          '& .MuiButton-startIcon': {
            margin: 0
          }
        }}
      />
      <Box display="flex" gap={2}>
        <GridToolbarQuickFilter
          sx={{
            verticalAlign: 'middle',
            marginBottom: 0,
            paddingBottom: 0
          }}
        />
        <GridToolbarExport
          sx={{
            '&.MuiButton-root': {
              backgroundColor: '#FC3E6F',
              color: 'white',
              minWidth: 'auto',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: '#e53958'
              }
            }
          }}
        />
      </Box>
    </GridToolbarContainer>
  )
}
